/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

import { SxProps } from '@mui/material';

export const headerItemStackSX: SxProps = {
	color: 'text.primary',
	'&:hover': {
		color: 'primary.main',
	},
	lineHeight: 0,
	cursor: 'pointer',
};
